export interface CanvasLayoutSyncState {
  width: number;
  height: number;
}

export interface CanvasLayoutSize {
  width: number;
  height: number;
}

export function createCanvasLayoutSyncState(): CanvasLayoutSyncState {
  return { width: 0, height: 0 };
}

export function shouldSyncCanvasLayout(
  state: CanvasLayoutSyncState,
  size: CanvasLayoutSize,
  force = false,
): boolean {
  const width = Math.round(size.width);
  const height = Math.round(size.height);
  if (width < 1 || height < 1) return false;

  if (!force && state.width === width && state.height === height) return false;

  state.width = width;
  state.height = height;
  return true;
}
